import React from "react";
import { Text, View } from "../Base";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles({
  iconContainer: {
    width: "26px",
    height: "26px",
    borderRadius: "4px",
    backgroundColor: (props) => props.backgroundColor,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

export const LegendTextIcon = (props) => {
  const { backgroundColor, text } = props;
  const styles = useStyles({ backgroundColor });

  return (
    <View className={styles.iconContainer}>
      <Text>{text}</Text>
    </View>
  );
};
